export default __webpack_public_path__ + "static/media/unofficial_mascot.ab0df104.png";